export const checkLanguage = language => {
  if (language === "fr") {
    return "en";
  }
  return language;
};
